import { Tags } from '@plone/volto/components';

const slots = {
  belowContent: [
    {
      name: 'tags',
      component: Tags,
    },
  ],
};

export default slots;
